<div class="card">
    <p-fieldset class="title-legend" legend="Ordem de Serviço">
        <div class="formgrid grid m-0">
            <div class="field col-12 md:col-4 lg:col-3">
                <label for="">OS</label>
                <input class="w-full p-inputtext-sm" pInputText maxlength="100" [(ngModel)]="dadosForm.numeroOS" (blur)="checarNumeroOS()" [disabled]="os_numero_readonly" />
            </div>
        </div>
    </p-fieldset>

    <p-fieldset class="title-legend" legend="Anexos">
        <div class="anexos-existentes" *ngIf="anexosExistentes.length">
            <h4>Anexos já enviados</h4>
            <div class="anexos-grid">
                <a *ngFor="let anexo of anexosExistentes" class="anexo-item" [href]="anexo.url" [download]="anexo.nome_arquivo" target="_blank" [title]="anexo.nome_arquivo">
                    <p-button class="anexo-remover" icon="pi pi-times" [rounded]="true" [text]="true" severity="danger" (click)="$event.preventDefault(); $event.stopPropagation(); removerAnexoExistente.emit(anexo)" title="Remover anexo"></p-button>
                    <img *ngIf="anexo.isImagem" [src]="anexo.url" [alt]="anexo.nome_arquivo">
                    <i *ngIf="!anexo.isImagem" class="pi pi-file anexo-icone"></i>
                    <span class="anexo-nome">{{ anexo.nome_arquivo }}</span>
                </a>
            </div>
        </div>

        <p-fileUpload #fileUpload [maxFileSize]="1024 * 1024 * 8" [fileLimit]="5" [invalidFileSizeMessageDetail]="'Tamanho máximo de arquivo excedido (8 MB)'" [invalidFileLimitMessageDetail]="'Número máximo de 5 arquivos excedido.'" [multiple]="true" (onSelect)="onAnexosSelect($event)" (onRemove)="onAnexosRemove($event)" (onClear)="onAnexosClear($event)" chooseLabel="Selecionar" uploadLabel="Enviar" cancelLabel="Limpar" [showUploadButton]="false">

        </p-fileUpload>
    </p-fieldset>

    <app-novo-pedido-outros-servicos [legend]="'Itens'" [servicosAdicionados]="servicosAdicionados" [laboratorioSelecionado]="laboratorioSelecionado"></app-novo-pedido-outros-servicos>
</div>
